// // components/TopNavbar.js
// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import logo from "../Logos/hvac-logo-new.jpg";
// import baseURL from "../ApiUrl/Apiurl";
// import { useCompany } from "../AuthContext/CompanyContext";

// const TopNavbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userRole = localStorage.getItem("userRole");
//   const userId = localStorage.getItem("userId");
//  const { selectedCompany, updateCompany } = useCompany();
//   const [userData, setUserData] = useState(null);
//   // const [selectedCompany, setSelectedCompany] = useState("");

//   const handleLogout = () => {
//     localStorage.removeItem("userRole");
//     localStorage.removeItem("userId");
//       localStorage.removeItem("selectedCompany");
//     navigate("/");
//   };

// useEffect(() => {
//     if (userRole === "Admin" && userId) {
//       fetch(`${baseURL}/users/`)
//         .then((res) => res.json())
//         .then((data) => {
//           const matchedUser = Array.isArray(data)
//             ? data.find((user) => user.user_id === userId)
//             : null;

//           if (matchedUser) {
//             setUserData(matchedUser);
//             const storedCompany = localStorage.getItem("selectedCompany");
//             if (!storedCompany) {
//               updateCompany(matchedUser.default_company);
//             }
//           }
//         })
//         .catch((err) => console.error("Failed to load user data", err));
//     }
//   }, [userRole, userId]);

//   if (userRole !== "Admin") return null;

//   const navItems = [
//     { path: "/admin/component", label: "Components" },
//     { path: "/admin/products", label: "Products" },
//     { path: "/admin/resource-management", label: "Resources" },
//     { path: "/admin/user-management", label: "Users" },
//   ];

//   const handleCompanyChange = (e) => {
//     updateCompany(e.target.value);
//   };

//   return (
//     <nav className="top-navbar">
//       <div className="nav-container">
//         <div className="nav-brand">
//           <img src={logo} alt="Company Logo" style={{ width: "100px", height: "50px" }} />
//         </div>

//         <div className="nav-links">
//           {navItems.map((item) => (
//             <Link
//               key={item.path}
//               to={item.path}
//               className={location.pathname === item.path ? "active" : ""}
//             >
//               {item.label}
//             </Link>
//           ))}

//           {userData && (
//             <select
//         className="form-select ms-3"
//         value={selectedCompany}
//         onChange={handleCompanyChange}
//         style={{ minWidth: "150px" }}
//       >
//               <option value={userData.default_company}>
//                 {userData.default_company}
//               </option>
//               {Array.isArray(userData.companies) &&
//                 userData.companies
//                   .filter((comp) => comp !== userData.default_company)
//                   .map((comp) => (
//                     <option key={comp} value={comp}>
//                       {comp}
//                     </option>
//                   ))}
//             </select>
//           )}
//         </div>

//         <div className="nav-user">
//           <button onClick={handleLogout} className="logout-btn">
//             Logout
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default TopNavbar;


//===================================================================

// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import logo from "../Logos/hvac-logo-new.jpg";
// import baseURL from "../ApiUrl/Apiurl";
// import { useCompany } from "../AuthContext/CompanyContext";

// const TopNavbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userRole = localStorage.getItem("userRole");
//   const userId = localStorage.getItem("userId");
//   const { selectedCompany, updateCompany } = useCompany();
//   const [userData, setUserData] = useState(null);
//   const [companiesData, setCompaniesData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const handleLogout = () => {
//     localStorage.removeItem("userRole");
//     localStorage.removeItem("userId");
//     localStorage.removeItem("selectedCompany");
//     updateCompany("");
//     navigate("/");
//   };

//   // Fetch companies data
//   const fetchCompanies = async () => {
//     try {
//       const response = await fetch(`${baseURL}/companies/`);
//       const data = await response.json();
//       if (data.status === "success") {
//         setCompaniesData(data.data);
//       }
//     } catch (error) {
//       console.error("Failed to load companies data", error);
//     }
//   };

//   // Function to get company display name in format: "TCS (COMP1)"
//   const getCompanyDisplayName = (companyId) => {
//     if (!companiesData || companiesData.length === 0) return companyId;
    
//     const company = companiesData.find(comp => comp.company_id === companyId);
//     if (company) {
//       return `${company.company_name} (${company.company_id})`;
//     }
//     return companyId;
//   };

//   useEffect(() => {
//     if (userRole === "Admin" && userId) {
//       setLoading(true);
      
//       // Fetch companies first
//       fetchCompanies().then(() => {
//         // Then fetch user data
//         fetch(`${baseURL}/users/`)
//           .then((res) => res.json())
//           .then((data) => {
//             const matchedUser = Array.isArray(data)
//               ? data.find((user) => user.user_id === userId)
//               : null;

//             if (matchedUser) {
//               setUserData(matchedUser);
//               const storedCompany = localStorage.getItem("selectedCompany");
//               if (!storedCompany) {
//                 updateCompany(matchedUser.default_company);
//               }
//             }
//             setLoading(false);
//           })
//           .catch((err) => {
//             console.error("Failed to load user data", err);
//             setLoading(false);
//           });
//       });
//     }
//   }, [userRole, userId, updateCompany]);

//   if (userRole !== "Admin") return null;

//   const navItems = [
//     { path: "/admin/component", label: "Components" },
//     { path: "/admin/products", label: "Products" },
//     { path: "/admin/resource-management", label: "Resources" },
//     { path: "/admin/user-management", label: "Users" },
//   ];

//   const handleCompanyChange = (e) => {
//     updateCompany(e.target.value);
//   };

//   if (loading) {
//     return (
//       <nav className="top-navbar">
//         <div className="nav-container">
//           <div className="nav-brand">
//             <img src={logo} alt="Company Logo" style={{ width: "100px", height: "50px" }} />
//           </div>
//           <div className="nav-links">
//             <span>Loading companies...</span>
//           </div>
//         </div>
//       </nav>
//     );
//   }

//   return (
//     <nav className="top-navbar">
//       <div className="nav-container">
//         <div className="nav-brand">
//           <img src={logo} alt="Company Logo" style={{ width: "100px", height: "50px" }} />
//         </div>

//         <div className="nav-links">
//           {navItems.map((item) => (
//             <Link
//               key={item.path}
//               to={item.path}
//               className={location.pathname === item.path ? "active" : ""}
//             >
//               {item.label}
//             </Link>
//           ))}

//           {userData && (
//             <select
//               className="form-select ms-3"
//               value={selectedCompany}
//               onChange={handleCompanyChange}
//               style={{ minWidth: "220px" }}
//               title={getCompanyDisplayName(selectedCompany)}
//             >
//               <option value={userData.default_company}>
//                 {getCompanyDisplayName(userData.default_company)}
//               </option>
//               {Array.isArray(userData.companies) &&
//                 userData.companies
//                   .filter((comp) => comp !== userData.default_company)
//                   .map((comp) => (
//                     <option key={comp} value={comp}>
//                       {getCompanyDisplayName(comp)}
//                     </option>
//                   ))}
//             </select>
//           )}
//         </div>

//         <div className="nav-user">
//           <button onClick={handleLogout} className="logout-btn">
//             Logout
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default TopNavbar;


import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../Logos/hvac-logo-new.jpg";
import baseURL from "../ApiUrl/Apiurl";
import { useCompany } from "../AuthContext/CompanyContext";

const TopNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const { selectedCompany, updateCompany } = useCompany();
  const [userData, setUserData] = useState(null);
  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("");

  const handleLogout = () => { 
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedCompany");
    localStorage.removeItem("session_id");
    updateCompany("");
    navigate("/");
  };

  // Fetch companies data
  const fetchCompanies = async () => {
    try {
      const response = await fetch(`${baseURL}/companies/`);
      const data = await response.json();
      if (data.status === "success") {
        setCompaniesData(data.data);
      }
    } catch (error) {
      console.error("Failed to load companies data", error);
    }
  };

  // Function to get company display name in format: "TCS (COMP1)"
  const getCompanyDisplayName = (companyId) => {
    if (!companiesData || companiesData.length === 0) return companyId;
    
    const company = companiesData.find(comp => comp.company_id === companyId);
    if (company) {
      return `${company.company_name} (${company.company_id})`;
    }
    return companyId;
  };

 // Fetch user data and set username
const fetchUserData = async () => {
  try {
    const response = await fetch(`${baseURL}/users/`);
    const data = await response.json();
    
    // Check if data is paginated (has data property) or array
    let usersArray = [];
    if (data && data.data && Array.isArray(data.data)) {
      // Paginated response
      usersArray = data.data;
    } else if (Array.isArray(data)) {
      // Old non-paginated response
      usersArray = data;
    }
    
    // If user not found in first page, fetch all pages
    let matchedUser = usersArray.find((user) => user.user_id === userId);
    
    // If not found and pagination exists, fetch all pages
    if (!matchedUser && data.pagination) {
      const totalPages = data.pagination.total_pages;
      for (let page = 2; page <= totalPages; page++) {
        const pageResponse = await fetch(`${baseURL}/users/?page=${page}`);
        const pageData = await pageResponse.json();
        if (pageData && pageData.data && Array.isArray(pageData.data)) {
          matchedUser = pageData.data.find((user) => user.user_id === userId);
          if (matchedUser) break;
        }
      }
    }
    
    if (matchedUser) {
      setUserData(matchedUser);
      setUsername(matchedUser.username || matchedUser.full_name);
      
      const storedCompany = localStorage.getItem("selectedCompany");
      if (!storedCompany) {
        updateCompany(matchedUser.default_company);
      }
    }
  } catch (error) {
    console.error("Failed to load user data", error);
  }
};

  useEffect(() => {
    if (userRole === "Admin" && userId) {
      setLoading(true);
      
      // Fetch companies first, then user data
      fetchCompanies().then(() => {
        fetchUserData().finally(() => {
          setLoading(false);
        });
      });
    }
  }, [userRole, userId, updateCompany]);

  if (userRole !== "Admin") return null;

  const navItems = [
    { path: "/admin/component", label: "Components" },
    { path: "/admin/products", label: "Products" },
    { path: "/admin/resource-management", label: "Resources" },
    { path: "/admin/user-management", label: "Users" },
  ];

  const handleCompanyChange = (e) => {
    updateCompany(e.target.value);
  };

  if (loading) {
    return (
      <nav className="top-navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logo} alt="Company Logo" style={{ width: "100px", height: "50px" }} />
          </div>
          <div className="nav-links">
            <span style={{ color: "white" }}>Loading...</span>
          </div>
          <div className="nav-user">
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="top-navbar">
      <div className="nav-container">
        <div className="nav-brand">
          <img src={logo} alt="Company Logo" style={{ width: "100px", height: "50px" }} />
        </div>

        <div className="nav-links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? "active" : ""}
            >
              {item.label}
            </Link>
          ))}

          {userData && (
            <select
              className="form-select ms-3"
              value={selectedCompany}
              onChange={handleCompanyChange}
              style={{ minWidth: "220px" }}
              title={getCompanyDisplayName(selectedCompany)}
            >
              <option value={userData.default_company}>
                {getCompanyDisplayName(userData.default_company)}
              </option>
              {Array.isArray(userData.companies) &&
                userData.companies
                  .filter((comp) => comp !== userData.default_company)
                  .map((comp) => (
                    <option key={comp} value={comp}>
                      {getCompanyDisplayName(comp)}
                    </option>
                  ))}
            </select>
          )}
        </div>

        <div className="nav-user">
          {/* Display username with greeting */}
          {username && (
            <span className="user-greeting">
              Hi, {username}
            </span>
          )}
          
          {/* Notification bell icon can be added here */}
          {/* <button className="notification-bell">
            <i className="bell-icon">🔔</i>
          </button> */}
          
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar; 




